export default {
  PartnerCrmImpersonateAccount: 'PartnerCrmImpersonateAccount',
};
